import { useEffect, useState } from "react";
import { APIConstants } from "../../constants/ApiConstants";
import axios from "axios";

const useGetCarparkBalance = () => {
  const [balance, setBalance] = useState("");
  const getCarparkBalance = async (memberDetails: any) => {
    try {

      const carParkBalance = await axios.get(
        process.env.REACT_APP_API_URL +
          `${APIConstants.carParkBalance}?email=${memberDetails.email}`
      );

      const carBalance = carParkBalance?.data?.currentAmount;
      setBalance(carBalance);
    } catch (err) {
      console.error(err);
    } finally {
    }
  };
  return { getCarparkBalance, balance };
};

export default useGetCarparkBalance;
